import { EQIP_IRRIGATION_QUANTITY_OPTIONS, ResourceDetail } from '@cibo/core'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useEffect, useState } from 'react'
import { TraitCellEditorProps } from '../../types'

import { useTranslation } from 'react-i18next'

const answerFromDetail = (detail?: ResourceDetail) => {
  return detail?.result === undefined ? '' : detail?.result?.irrigationQuantity
}

export const EqipIrrigationQuantityCellEditor = ({
  traitId,
  year,
  params,
  saveDetail,
  removeDetail,
}: TraitCellEditorProps) => {
  const { t } = useTranslation('@cibo/landmanager/EqipIrrigationQuantity')
  const detail = params.row.findDetail({ traitId, year })
  const [answer, setAnswer] = useState(answerFromDetail(detail))

  useEffect(() => {
    setAnswer(answerFromDetail(detail))
  }, [detail])

  const handleChange = (_: any, value: any) => {
    setAnswer(value)

    if (value === '') {
      removeDetail({
        resourceId: params.row.resourceId,
        traitId,
        year,
      })
    } else {
      saveDetail({
        resourceId: params.row.resourceId,
        details: [{ traitId, year, input: { irrigationQuantity: value } }],
      })
    }
  }

  return (
    <ToggleButtonGroup
      exclusive
      value={answer}
      onChange={handleChange}
      sx={{ marginRight: 1 }}
      data-testid={`eqip-irrigation-quantity_editor`}
    >
      {EQIP_IRRIGATION_QUANTITY_OPTIONS.map(answer => (
        <ToggleButton
          key={answer}
          value={answer}
          aria-label={t(`irrigationQuantity_${answer}`) as string}
        >
          {t(`irrigationQuantity_${answer}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
